module.exports = "<ll-billing-activity matter=\"vm.module.matter\" />";